var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',{attrs:{"heading":_vm.$t('heading')}},[_c('v-card',[_c('invoices-overview')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }